import "./index.css";
import "./auth/amplify.ts";
import "./api/setup.ts";
import "./i18n";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster, TooltipProvider } from "./components/ui";

import { RouterProvider } from "react-router-dom";
import { StrictMode } from "react";
import { ThemeProvider } from "./theme/ThemeProvider.tsx";
import { createRoot } from "react-dom/client";
import { router } from "./routes";

const chunkRecoveryStorageKey = "floorbit:chunk-recovery-build";

function installChunkLoadRecovery() {
  const currentBuild =
    document
      .querySelector<HTMLScriptElement>('script[type="module"][src]')
      ?.src.toString() ?? "unknown-build";

  window.addEventListener("vite:preloadError", (event) => {
    try {
      if (sessionStorage.getItem(chunkRecoveryStorageKey) === currentBuild) {
        return;
      }

      sessionStorage.setItem(chunkRecoveryStorageKey, currentBuild);
    } catch {
      // Without session storage we cannot safely prevent a reload loop.
      return;
    }

    event.preventDefault();
    window.location.reload();
  });
}

installChunkLoadRecovery();

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider storageKey="floorbit-theme" defaultTheme="system">
        <TooltipProvider>
          <RouterProvider router={router} />
          <Toaster />
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
